import { BadgeV3, ColorOption } from '@cimplico/components';

type BadgeProps = {
    label: string;
    color: ColorOption;
    onClick?: () => void;
};

/**
 * Badge to be placed between author label and message content
 */
function Badge({ label, color, onClick }: BadgeProps): JSX.Element {
    return (
        <div onClick={onClick} className={`${onClick ? 'cursor-pointer' : ''} pt-2`}>
            <BadgeV3 label={label} rounded size="small" color={color} />
        </div>
    );
}

export default Badge;
